import type { NewUserQuizCopy } from '../types';

export const DE_NEW_USER_QUIZ_COPY = {
  booking: {
    bookedSnackbar: 'Deine Demo ist gebucht – bis bald!',
    bullets: {
      pricing: 'Klare Preise nach Volumen und Support-Level',
      teams: 'Für Teams gemacht: Reviewer, Glossare, eine gemeinsame Bibliothek',
      setup: 'Finde das passende Setup für deine Inhalte und deinen Workflow',
    },
    description: 'Erfahre, wie Rask Identität, Intention und Kontext über Sprachgrenzen hinweg bewahrt.',
    heading: 'Sieh, wie Rask in deinen Workflow passt',
    headingSecondLine: 'Demo buchen: Rask in Aktion erleben',
    maybeLater: 'Vielleicht später',
    rating: '4,7/5 auf G2',
    scheduler: {
      openBookingPage: 'Buchungsseite öffnen',
      loadErrorDescription:
        'Dein Netzwerk oder deine Region blockiert möglicherweise die Einbettung. Öffne stattdessen die Buchungsseite in einem neuen Tab.',
      loadErrorTitle: 'Der Terminplaner konnte nicht geladen werden',
      loadingLabel: 'Terminplaner wird geladen',
    },
    trustedBy: 'Weltweit von Teams geschätzt',
  },
  controls: {
    back: 'Zurück',
    continue: 'Weiter',
    continueAnyway: 'Trotzdem fortfahren',
    progress: (currentStep, totalSteps) => `Frage ${currentStep} von ${totalSteps}`,
    submitError: 'Deine Antworten konnten nicht gespeichert werden. Bitte versuche es erneut.',
  },
  priorityQuestion: {
    title: 'Was ist dir bei der Videolokalisierung am wichtigsten?',
    options: {
      collaborate_with_team_or_reviewers: { label: 'Zusammenarbeit mit Team oder Reviewern' },
      consistent_voice_and_terminology: { label: 'Einheitliche Stimme und Terminologie' },
      fast_results_no_setup: { label: 'Schnelle Ergebnisse, keine Einrichtung nötig' },
      integration_into_product_or_workflow: { label: 'Integration in unser Produkt oder unseren Workflow' },
      not_sure_yet: { label: 'Noch nicht sicher' },
    },
    subtitle: 'Wähle alle zutreffenden Optionen aus',
  },
  questions: {
    content_team_size: {
      title: 'Wie groß ist dein Content-Team?',
      options: {
        just_me: { label: 'Nur ich' },
        large_team_5_plus: { label: 'Ein großes Team', description: '5 oder mehr Personen' },
        small_team_2_5: { label: 'Ein kleines Team', description: '2 bis 5 Personen' },
      },
    },
    localization_frequency: {
      title: 'Wie oft übersetzt, vertonst oder lokalisierst du Videos?',
      options: {
        continuously: { label: 'Kontinuierlich', description: 'Kontinuierlicher Bedarf' },
        occasionally_quarterly: { label: 'Gelegentlich', description: 'Etwa einmal pro Quartal' },
        regularly_monthly: { label: 'Regelmäßig', description: 'Jeden Monat' },
        one_time_project: { label: 'Einmaliges Projekt', description: 'Ein einzelnes Projekt' },
      },
    },
    localized_videos_before: {
      title: 'Hast du schon einmal Videos lokalisiert?',
      options: {
        false: { label: 'Nein' },
        true: { label: 'Ja' },
      },
      subtitle: 'Ein paar kurze Fragen, um dein Erlebnis zu personalisieren',
    },
    target_language_count: {
      title: 'Für wie viele Sprachen planst du die Lokalisierung?',
      options: {
        changes_by_project: { label: 'Je nach Projekt', description: 'Keine feste Anzahl' },
        four_to_ten: { label: '4 – 10', description: 'Mehrere Märkte gleichzeitig' },
        ten_plus: { label: '10+', description: 'Umfangreicher Rollout' },
        two_to_three: { label: '2 – 3', description: 'Ein paar Märkte' },
        one: { label: '1', description: 'Nur eine Sprache' },
      },
    },
  },
} satisfies NewUserQuizCopy;
